<template>
  <v-dialog
    persistent
    v-model="openDialog"
    @keydown.esc="openDialog = false"
    max-width="500"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="title pb-0">Change Primary Contact</v-card-title>
      <v-card-text>
        <v-alert class="text-xs-left" type="info" :value="true" outline>
          This will also copy over the contact tags of the previous primary
          contact to the new primary contact
        </v-alert>
        <v-select
          class="default-input"
          v-model="newPrimaryContactId"
          :items="ownerOptions"
          placeholder="Select New Primary Contact"
          solo
          item-text="full_name"
          item-value="id"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="primary text-none"
          :loading="changing"
          :disabled="!newPrimaryContactId"
          @click="changePrimaryContact()"
        >
          Save
        </v-btn>
        <v-btn class="error--text text-none" flat @click="openDialog = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';
import { mapState } from 'vuex';

export default {
  name: 'SwitchPrimaryContactDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    ownerOptions: {
      type: Array,
    },
    currentCompanyId: {
      type: Number,
    },
  },
  computed: {
    ...mapState('companies', ['companies']),
  },
  watch: {
    value(newVal) {
      this.openDialog = newVal;
    },
    openDialog(newVal) {
      this.$emit('input', newVal);
    },
  },
  methods: {
    async changePrimaryContact() {
      try {
        this.changing = true;
        const response = await API.company.changePrimaryContact({
          newPrimaryContactId: this.newPrimaryContactId,
          companyId: this.currentCompanyId,
        });
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('setDefaultCompany', {
            companyId: this.currentCompanyId,
          });
          this.$store.dispatch('companies/getCompanies');
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully updated!',
          });
          this.newPrimaryContactId = null;
          this.$emit('refresh');
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.changing = false;
        this.openDialog = false;
      }
    },
  },
  data() {
    return {
      openDialog: false,
      changing: false,
      newPrimaryContactId: null,
    };
  },
  created() {
    this.openDialog = this.value;
  },
};
</script>

<style scoped></style>
